import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { jfrogConfig } from 'pages/provisioning/day2/github-onboarding-new/store';

export function buildResolvedRepoConfig({ repoName, isMigrationFlow, apiResults, reposToMigrateList, order }) {
    let resolvedApiItem;
    if (isMigrationFlow) {
        const migrationMapping = reposToMigrateList?.find((entry) => entry?.githubName === repoName || entry?.githubEnterpriseName === repoName);
        const resolvedAdoName = migrationMapping?.adoName || repoName;
        resolvedApiItem = apiResults.find((result) => result?.repoName === resolvedAdoName);
    } else {
        const microserviceConfig = order?.microservicesConfigs?.find((m) => m?.newgithubRepositoryName === repoName);
        if (microserviceConfig?.templateLanguage && microserviceConfig?.templateBuildTool) {
            resolvedApiItem = apiResults.find(
                (result) =>
                    result?.applicationType?.toLowerCase() === microserviceConfig.templateLanguage?.toLowerCase() &&
                    result?.packageManager?.toLowerCase() === microserviceConfig.templateBuildTool?.toLowerCase()
            );
        }
    }

    return {
        repositoryName: repoName,
        isNoneBuildTool: false,
        jfrogGlobalRepo: resolvedApiItem?.jfrogGlobalRepo ?? null,
        jfrogRepoName: resolvedApiItem?.jfrogGlobalRepo || '',
        applicationType: resolvedApiItem?.applicationType || null,
        packageManager: resolvedApiItem?.packageManager || null,
        resolvedMessage: resolvedApiItem?.jfrogGlobalRepo ? resolvedApiItem?.message || null : null,
        resolveError: resolvedApiItem?.jfrogGlobalRepo ? null : resolvedApiItem?.message || null,
        jfrogRepoDetails: null,
        isValidated: !!resolvedApiItem?.jfrogGlobalRepo,
        resolveAttempted: true,
    };
}

const useJfrogRepoConfiguration = (index) => {
    const [jfrogConfiguration, setJfrogConfiguration] = useRecoilState(jfrogConfig);
    const currentConfig = jfrogConfiguration?.repoConfigurations?.[index] || {};

    const updateFields = useCallback(
        (fields) => {
            setJfrogConfiguration((prev) => {
                const updatedRepoConfigurations = [...(prev?.repoConfigurations || [])];
                if (updatedRepoConfigurations[index]) {
                    updatedRepoConfigurations[index] = {
                        ...updatedRepoConfigurations[index],
                        ...fields,
                    };
                }
                return {
                    ...prev,
                    repoConfigurations: updatedRepoConfigurations,
                };
            });
        },
        [index]
    );

    return {
        config: currentConfig,
        jfrogConfiguration,
        updateFields,
    };
};

export default useJfrogRepoConfiguration;
